<template>
  <the-layout>
    <van-loading v-if="loading" size="24px" vertical>{{
      loadingText
    }}</van-loading>
    <template v-else>
      <van-empty v-if="error" image="error" :description="errorText" />
      <slot v-else></slot>
    </template>
  </the-layout>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: "加载中...",
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: "获取数据失败",
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
